import React from 'react';

import { UPDATE_FIELDS_CONFIG } from './queries.tsx';
import * as DocumentQueries from './queries.tsx';
import { HEADER_SECTION, itemSection } from '../../../document/components/FieldsPage.tsx';
import { DocumentType } from '../../../document/constants.ts';
import DocumentConfiguration, {
    CONFIG_OPTION,
    CONFIG_GROUP,
    createFieldsConfig,
    DEFAULT_CONFIGS,
} from '../../../document/pages/Configuration';
import ListOfServicesKeywordsConfig from '../components/ListOfServicesKeywordsConfig.tsx';
import ListOfServicesOutputMapperPanel from '../components/ListOfServicesOutputMapperPanel.tsx';
import ListOfServicesXmlSerializerConfig from '../components/ListOfServicesXmlSerializerConfig.tsx';
import { CHANNEL_CONFIG_PATH, CHANNEL_PATH, OVERVIEW_PATH } from '../constants.ts';
import { GET_OVERVIEW_DATA } from '../queries.ts';

const DefaultDocumentConfig = DEFAULT_CONFIGS[CONFIG_OPTION.Document];

const Configuration = (props) => {
    const configOptions = {
        [CONFIG_OPTION.General]: DEFAULT_CONFIGS[CONFIG_OPTION.General],
        // List-of-services shows the highlight keyword list as a "Keywords" card within the Document section.
        [CONFIG_OPTION.Document]: (documentConfigProps) => {
            const { channel, handlers } = documentConfigProps;
            return (
                <div className="flex flex-col gap-7">
                    <DefaultDocumentConfig {...documentConfigProps} />
                    <ListOfServicesKeywordsConfig
                        config={channel}
                        onSubmit={(formData) => handlers.onUpdate(formData)}
                    />
                </div>
            );
        },
        [CONFIG_OPTION.Fields]: createFieldsConfig([
            HEADER_SECTION,
            // a bill of quantities' positions are its line items
            itemSection('positions', 'configPage.document.fieldSections.lineItems'),
            // the article fields under positions__article_sets__ have their own section
            itemSection('positions__article_sets__articles', 'configPage.document.fieldSections.articles'),
        ]),
        [CONFIG_OPTION.XmlSerializer]: ({ channel, handlers }) => {
            return (
                <ListOfServicesXmlSerializerConfig
                    config={channel?.xmlSerializerConfig}
                    useOutputMapping={channel?.useOutputMapping}
                    channelId={channel?.id}
                    onActivate={() => handlers.onCreate('xml_serializer_config')}
                    onSubmit={(formData, channelFields) =>
                        handlers.onUpdate({ xmlSerializerConfig: formData, ...channelFields })
                    }
                />
            );
        },
        [CONFIG_OPTION.MasterData]: DEFAULT_CONFIGS[CONFIG_OPTION.MasterData],
        [CONFIG_OPTION.CustomizationParams]: DEFAULT_CONFIGS[CONFIG_OPTION.CustomizationParams],
        [CONFIG_OPTION.SFTP]: DEFAULT_CONFIGS[CONFIG_OPTION.SFTP],
        [CONFIG_OPTION.AS2]: DEFAULT_CONFIGS[CONFIG_OPTION.AS2],
        [CONFIG_OPTION.Upload]: DEFAULT_CONFIGS[CONFIG_OPTION.Upload],
    };

    const configGroups = {
        [CONFIG_GROUP.General]: [CONFIG_OPTION.General],
        [CONFIG_GROUP.Input]: [],
        [CONFIG_GROUP.Processing]: [
            CONFIG_OPTION.Document,
            CONFIG_OPTION.Fields,
            CONFIG_OPTION.CustomizationParams,
            CONFIG_OPTION.MasterData,
        ],
        [CONFIG_GROUP.Output]: [
            CONFIG_OPTION.AS2,
            CONFIG_OPTION.SFTP,
            CONFIG_OPTION.Upload,
            CONFIG_OPTION.XmlSerializer,
        ],
    };

    // Output mapper is only visible to support users.
    const supportUserConfigs = {
        [CONFIG_OPTION.OutputMapper]: ({ channel }) => <ListOfServicesOutputMapperPanel channelId={channel?.id} />,
    };

    const supportUserConfigGroups = {
        [CONFIG_GROUP.Output]: [CONFIG_OPTION.OutputMapper],
    };

    const documentConfiguration = {
        service: 'list_of_services',
        documentType: DocumentType.ListOfServices,
        documentTypeName: 'listOfServices',
        activeTab: 'list-of-services',
        documentQueries: DocumentQueries,
        getOverviewData: GET_OVERVIEW_DATA,
        channelPath: CHANNEL_PATH,
        overviewPath: OVERVIEW_PATH,
        configPath: CHANNEL_CONFIG_PATH,
        configOptions: configOptions,
        configGroups: configGroups,
        supportUserConfigs: supportUserConfigs,
        supportUserConfigGroups: supportUserConfigGroups,
        updateMutation: UPDATE_FIELDS_CONFIG,
    };

    return <DocumentConfiguration documentConfiguration={documentConfiguration} {...props} />;
};

export default Configuration;
